import { NgxSpinnerService } from "ngx-spinner";
import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";

import { Sensor } from "../../models/Sensor.model";
import { SensorInterface } from "../../contracts/Sensor.interface";
import { PermissionsService } from "src/app/helpers/permissions.service";
import { Page } from "src/app/utils/paginate";
import { ApiBaseService } from "src/app/services/migrate/api.base.service";
import {
  STORAGE_KEY_CURRENT_USER,
  STORAGE_KEY_ID_PERFIL,
} from "src/app/storageCore/constStorageKeys";
import storageX from "src/app/storageCore/storageX";
import Swal from "sweetalert2";

@Component({
  selector: "app-sensor",
  templateUrl: "./sensor.component.html",
  styleUrls: ["./sensor.component.scss"],
})
export class SensorComponent implements OnInit {
  permissions: [];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public filter: string = '';
  public filterPlaca: string = '';
  public typeFilter;

  public page = new Page();
  public errorMessage;
  public loader = false;
  public length = 0;
  public pageSize = 10;
  public totalElements = 0;
  public totalPages = 0;
  public currentPage = 0;

  public displayedColumns: string[] = [
    "id",
    "codigoSensor",
    "nome",
    "placa",
    "update",
    "clone",
    "view",
    "delete",
  ];

  public retornoEntidades: MatTableDataSource<any>;

  public filtros = [{ campo: "codigoSensor", valor: "Descrição Sensor" }];

  private apiBaseService: ApiBaseService;

  public sensor: MatTableDataSource<SensorInterface>;

  constructor(
    apiBaseService: ApiBaseService,
    private spinner: NgxSpinnerService,
    public router: Router,
    public permissionService: PermissionsService
  ) {
    this.apiBaseService = apiBaseService;
    this.sensor = new MatTableDataSource<SensorInterface>([]);
  }

  ngOnInit(): void {
    this.loadSensor();
  }

  public handleSort = (sort): void => {
    this.currentPage = 0;
    this.loadSensor(0, sort);
  };

  public handlePageChanged = (event: PageEvent): void => {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadSensor(event.pageIndex);
  };

  public async handleDelete(element): Promise<void> {
    Swal.fire({
      icon: "warning",
      title: "Excluir Sensor",
      html: `<h6>Tem certeza que você deseja excluir o sensor
       <small><b> ${element.codigoSensor}</b>? </h6>`,
      showCloseButton: false,
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonText: "Cancelar",
      showConfirmButton: true,
      confirmButtonText: "Confirmar",
      focusConfirm: false,
    }).then((action) => {
      if (action.isConfirmed) {
        this.deleteSensor(element.id);
      }
    });
  }

  public handleUpdate = (id): void => {
    this.router.navigate([`/sensor/${id}`]);
  };

  ngAfterViewInit(): void {}

  public applyFilter(event: Event, filterType: string) {
    const filterValue = (event.target as HTMLInputElement).value;
    
    if (filterType === 'codigoSensor') {
      this.filter = filterValue.trim();
    } else if (filterType === 'placa') {
      this.filterPlaca = filterValue.trim();
    }
    
    this.currentPage = 0;
    this.loadSensor(0);
  }


  public async deleteSensor(id): Promise<void> {
    const idUsuario = storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id;
    try {
      this.spinner.show();

      await this.apiBaseService.delete<Sensor>(
        idUsuario,
        id,
        new Sensor()["nomeConsultaApiBase"]
      );

      this.spinner.hide();

      this.loadSensor();
    } catch (error) {
      this.spinner.hide();
      this.errorMessage = error.message;
      throw new EvalError(error);
    }
  }

  public async loadSensor(pageIndex = 0, sort?): Promise<void> {
    const params: any = {
      profileId: storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get(),
      size: this.pageSize,
      page: pageIndex,
    };

    // Adicionar filtros se existirem
    if (this.filter && this.filter.length > 0) {
      params.codigoSensor = this.filter;
    }
    
    if (this.filterPlaca && this.filterPlaca.length > 0) {
      params.placa = this.filterPlaca;
    }

    try {
      this.spinner.show();

      const result = await this.apiBaseService.get<any>({
        url: new Sensor()["nomeConsultaApiBaseGetAll"],
        params,
      });

      // Configurar dados da tabela
      this.retornoEntidades = new MatTableDataSource<any>(result.content);
      
      // Configurar informações de paginação
      this.totalElements = result.totalElements || result.content.length;
      this.totalPages = result.totalPages || Math.ceil(this.totalElements / this.pageSize);
      this.length = this.totalElements;

      // Configurar paginador e ordenação
      setTimeout(() => {
        if (this.retornoEntidades) {
          this.retornoEntidades.sort = this.sort;
          this.retornoEntidades.paginator = this.paginator;
        }
        this.spinner.hide();
      }, 300);

    } catch (error) {
      this.spinner.hide();
      this.errorMessage = error.message;
      throw new EvalError(error);
    }
  }
}
